import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';
import props from './props';

const theme = responsiveFontSizes(
  createMuiTheme({
    palette,
    typography,
    overrides,
    props,
    shape: {
      borderRadius: 8
    },
    zIndex: {
      appBar: 1200,
      drawer: 1100
    }
  })
);

export default theme;
